import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Always rendered so the user has a consistent place to look for the batch
// save.  Two distinct concepts here:
//   - `inert`  : click is a no-op (nothing to save / flush already running /
//                auto-save handling per-cell).
//   - `looksDisabled` : button is rendered greyed out.
// They overlap most of the time, but auto-save OFF with an empty queue is the
// case where we want the button to LOOK active (so the user sees they own the
// save action) while still being a no-op.  Click handling stays guarded by
// `inert` regardless of styling.
const SaveChangesButton = ({autoSave, pendingSaves, flushPendingSaves, mobile}) => {
  const [busy, setBusy] = useState(false);

  const count = pendingSaves ? Object.keys(pendingSaves).length : 0;
  const autoSaveOn = autoSave !== false;
  const inert = busy || autoSaveOn || count === 0;
  const looksDisabled = busy || autoSaveOn;

  const cls = classNames('btn btn-tait timesheet--save-batch', {
    'desktop-control': !mobile,
    'actions-sub-button': mobile,
    disabled: looksDisabled
  });

  const title = autoSaveOn
    ? 'Auto-save is ON - edits save per cell automatically.'
    : count === 0
      ? 'No queued changes to save.'
      : `Save ${count} queued change${count === 1 ? '' : 's'}.`;

  const onClick = async () => {
    if (inert) return;
    setBusy(true);
    try {
      await flushPendingSaves();
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={cls}
      disabled={looksDisabled}
      aria-disabled={inert}
      onClick={onClick}
      title={title}>
      <i className="fa fa-lg fa-save" aria-hidden="true" />
      {count > 0 && !autoSaveOn ? ` Save (${count})` : ' Save'}
    </button>
  );
};

SaveChangesButton.propTypes = {
  autoSave: PropTypes.bool,
  pendingSaves: PropTypes.object,
  flushPendingSaves: PropTypes.func.isRequired,
  mobile: PropTypes.bool
};

export default SaveChangesButton;
